import {LookupDTO, PayrollGroupDTO} from 'kashable-mobile-common';

import {RootState} from '../store';

import {createSlice, PayloadAction} from '@reduxjs/toolkit';

interface PayrollData {
    payroll: PayrollGroupDTO | undefined;
    payrollFrequencies: LookupDTO[] | undefined;
}

const initialState: PayrollData = {
    payroll: undefined,
    payrollFrequencies: undefined,
};

export const payrollSlice = createSlice({
    name: 'payroll',
    initialState,
    reducers: {
        updatePayroll: (state, action: PayloadAction<PayrollGroupDTO | undefined>) => {
            return {...state, payroll: action.payload};
        },
        updatePayrollFrequencies: (state, action: PayloadAction<LookupDTO[]>) => {
            return {...state, payrollFrequencies: action.payload};
        },
        clearPayroll: () => {
            return {...initialState};
        }
    },
});

export const selectPayroll = (state: RootState) => state.payroll;
export const {
    updatePayroll, 
    updatePayrollFrequencies, 
    clearPayroll
} = payrollSlice.actions;
export default payrollSlice.reducer;
